import React from 'react'
import { Fade } from 'react-awesome-reveal'
import Slider from 'react-slick';
import { appTesimonial } from '../../utility/appTesimonial';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


function AppTesimonial() {

    const settings = {
        dots: false,
        infinite: true,
        arrows: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1367,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 0,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <section className="section-testimonals padding-t-50 padding-b-100">
            <img src="assets/img/theme/services-shape-8.png" alt="services-shape-8" className="services-shape-8" />
            <div className="container">
                <Fade triggerOnce duration={1500} direction='up'>
                    <div className="row">
                        <div className="col-lg-6 col-sm-12">
                            <div className="zx-app-banner">
                                <h4>Testimonials</h4>
                                <h2>What Our Customers Say About Us</h2>
                            </div>
                        </div>
                        <div className="zx-app-testimonals">
                            <img src="assets/img/testimonials/testimonial.png" alt="testimonal" className="testimonal-image" />
                        </div>
                        <div className="col-lg-6 col-sm-12">
                            <img src="assets/img/theme/services-shape-5.png" alt="services-shape-5" className="services-shape-5" />
                            <div className="zx-app-testimonals-position">
                                <div className="zx-app-testimonial">
                                    <Slider {...settings} className="swiper-wrapper">
                                        {
                                            appTesimonial.map((data, index) => (
                                                <div key={index} className="zx-app-testimonals-domain swiper-slide">
                                                    <img src={data.image} alt="boys" />
                                                    <div className="zx-app-icon-star">
                                                        <i className="fa-solid fa-star"></i>
                                                        <i className="fa-solid fa-star"></i>
                                                        <i className="fa-solid fa-star"></i>
                                                        <i className="fa-solid fa-star"></i>
                                                        <i className="fa-solid fa-star"></i>
                                                    </div>
                                                    <p>
                                                        {data.discription}
                                                    </p>
                                                    <div className="borderd"></div>
                                                    <div className="zx-app-testimonial-text">
                                                        <h4>{data.name}</h4>
                                                        <p>{data.title}</p>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fade>
            </div>
        </section >
    )
}

export default AppTesimonial
